module.exports = __webpack_public_path__ + "img/chatbot.72b5fa73.svg";